import _extends from "@babel/runtime/helpers/extends";
import { WIX_STATUS_PAGE_LINK } from '../../consts';
import { TextButton, Text } from '@wix/design-system';
import React from 'react';
import { Trans } from '@wix/wix-i18n-config';
export const getFootNoteProps = _ref => {
  let {
    showStatusFootnote,
    transProps
  } = _ref;
  return showStatusFootnote ? {
    footnoteSkin: 'light',
    footnote: /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Trans, _extends({}, transProps, {
      i18nKey: "errors.status-page-foot-note"
    }), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      onClick: () => {
        window.open(WIX_STATUS_PAGE_LINK);
      }
    })))
  } : {};
};
//# sourceMappingURL=getFootNoteProps.js.map